import { navigate } from "@reach/router";
import { observer, inject } from "mobx-react";
import Button from "components/Button";
import eventStop from "components/ReactUtils/eventStop";
import FormStore from "components/Form/FormStore";
import Input from "components/Form/Input";
import React, { Component } from "react";

class AuthFormPasswordReset extends Component {
  store = new FormStore({
    data: {
      email: "",
    },
    constraints: {
      email: {
        presence: { message: "Bitte gib deine E-Mail Adresse an." },
        email: { message: "Bitte gib eine gültige E-Mail Adresse an." },
      },
    },
  });

  send = async e => {
    const { api } = this.props;
    eventStop(e);

    if (!(await this.store.validate())) {
      const { email } = this.store.toJS();

      await api
        .post("authPasswordForgot", { email, modelName: "Store", host: window.location.origin })
        .then(() => navigate("/login/forgot/sent"))
        .catch(({ error }) => this.store.setError("email", error.message));
    }
  };

  render() {
    const { className } = this.props;

    return (
      <div className={[className, "text-center"].join(" ")}>
        E-Mail Adresse angeben, um Passwort wiederherzustellen
        <form onSubmit={this.send}>
          <div className="_inputs">
            <Input type="text" store={this.store} name="email" label="E-Mail Adresse eingeben" />
          </div>
          <div>
            <Button type="submit">ABSENDEN</Button>
          </div>
        </form>
      </div>
    );
  }
}

AuthFormPasswordReset = observer(AuthFormPasswordReset);
AuthFormPasswordReset = inject("api")(AuthFormPasswordReset);

export default AuthFormPasswordReset;
